import { debugLog } from '@schibsted-nmp/advertising-shared';

import type { Api } from './Api/index.js';

const directlyRenderedSlotIds = new Set<string>();

export namespace DirectRenderedSlots {
  export function has(slotId: string): boolean {
    return directlyRenderedSlotIds.has(slotId);
  }

  export function consume(slotId: string): boolean {
    return directlyRenderedSlotIds.delete(slotId);
  }

  export function simulate(slotId: string) {
    directlyRenderedSlotIds.add(slotId);
    console.info(
      `[ADVT] Simulated direct render for slot '${slotId}' — it will be excluded from the next GAM refresh`
    );
  }

  export function register(relevantDigital: Api.Loaded) {
    relevantDigital.addAdsCallbacks({
      slotRenderEnded(ev) {
        if (!ev.directRender) return;

        const slotId = ev.slot.getSlotElementId();
        directlyRenderedSlotIds.add(slotId);

        debugLog(
          `Slot '${slotId}' was directly rendered by Relevant Yield, excluding from GAM refresh`
        );
      }
    });
  }
}
